// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

// Footer コピーライトマーク右側の年数表示用
document.getElementById('year').textContent = new Date().getFullYear();